import * as yup from "yup";

import { LENGTH_EQUAL } from "../../../constants/errors";
import { useErrorCodeTranslation } from "../../../hooks/errors";

const TOTP_CODE_LENGTH = 6;

export function useTwoFAConfirmationCode() {
  const { et } = useErrorCodeTranslation();

  return yup.object().shape({
    code: yup
      .string()
      .required()
      .length(
        TOTP_CODE_LENGTH,
        et(LENGTH_EQUAL, { $length: TOTP_CODE_LENGTH })
      ),
  });
}
